<template>
    <div v-if="rakenneElementti.valitavoitteet.length > 0" class="objectiveList">
        <template v-for="keino in rakenneElementti.valitavoitteet">
            <div class="objectiveListItem" :id="generateIdFromValitavoite(keino)">
                <div class="row">
                  <div class="col-lg-7 py-0">
                    <h4 class="objectiveName mb-4">{{ localizedStringValue(keino.nimi) }}</h4>
                    <div>
                      <div class="typeName mb-2 mr-5 float-left">
                        <font-awesome-icon :icon="getValitatavoitteenTyypinIkoni(keino.valitavoiteTyyppiUuid)" class="typeIcon" aria-hidden="true" role="presentation" />{{getValitatavoitteenTyypinNimi(keino.valitavoiteTyyppiUuid)}}
                      </div>
                      <div class="float-left">
                        <div class="status-and-date">
                          <template v-if="keino.valmis">
                            <font-awesome-icon :icon="['fa', 'calendar-check']" class="date-icon" aria-hidden="true" role="presentation"/>
                          </template>
                          <template v-else>
                            <font-awesome-icon :icon="['fa', 'hourglass-half']" class="date-icon" aria-hidden="true" role="presentation"/>
                          </template>
                          <template v-if="!keino.valmis && keino.vanhaTavoitekuukausi && keino.vanhaTavoitevuosi">
                            <span class="status"><span v-translate>to.be.ready</span>:</span>
                            <span>{{monthAndYearText(keino.vanhaTavoitekuukausi, keino.vanhaTavoitevuosi)}}</span>
                            <font-awesome-icon :icon="['fa', 'arrow-right']" class="separator"  :aria-label="getTranslation('timeline.updated')"/>
                            <span>{{monthAndYearText(keino.tavoitekuukausi, keino.tavoitevuosi)}}</span>
                          </template>
                          <template v-else-if="!keino.valmis">
                            <span class="status"><span v-translate>to.be.ready</span>:</span>
                            <span>{{monthAndYearText(keino.tavoitekuukausi, keino.tavoitevuosi)}}</span>
                          </template>
                          <template v-else>
                            <span class="status"><span v-translate>ready</span>:</span>
                            <span>{{monthAndYearText(keino.tavoitekuukausi, keino.tavoitevuosi)}}</span>
                          </template>
                        </div>
                      </div>
                      <div class="clear"></div>
                    </div>
                    <template v-if="keino.liittyvatKohdeUuids.length > 0 || keino.linkit.length > 0">
                      <div class="my-2">
                        <div class="links" v-if="keino.liittyvatKohdeUuids.length > 0">
                          <template v-for="kohde in keino.liittyvatKohdeUuids">
                            <template v-if="kohdeLinkkiExists(kohde)">
                              <a :href="getKohdeLinkki(kohde)" target="_blank"><span v-translate>assignment.in.progress</span>: {{ getKohdeTunnus(kohde) }}</a>
                              <br />
                            </template>
                          </template>
                        </div>
                        <div class="links" v-if="keino.linkit.length > 0">
                          <template v-for="linkki in keino.linkit">
                            <a :href="localizedStringValue(linkki.url)" target="_blank">
                              {{ localizedStringValue(linkki.nimi) }}
                              <font-awesome-icon :icon="['fas', 'external-link-alt']" class="external-link-icon" aria-hidden="true" role="presentation"/>
                            </a>
                            <br />
                          </template>
                          <template v-for="linkki in getKohteidenLinkit(keino)">
                            <a :href="localizedStringValue(linkki.url)" target="_blank">
                              {{ localizedStringValue(linkki.nimi) }}
                              <font-awesome-icon :icon="['fas', 'external-link-alt']" class="external-link-icon" aria-hidden="true" role="presentation"/>
                            </a>
                            <br />
                          </template>
                        </div>
                      </div>
                    </template>
                    <div>
                      <div class="mt-2 mr-5 float-left" v-if="keino.vastuuministerioUuids.length > 0">
                        <span class="d-inline-block mr-2 info-label" v-translate>responsible.ministry</span>
                        <template v-for="vastuuministerioUuid in keino.vastuuministerioUuids">
                            <span class="department-tag yja-tag">
                                {{ getMinisterioLyhenne(vastuuministerioUuid) }}
                            </span>
                        </template>
                      </div>
                      <div class="mt-2 float-left" v-if="keino.osavastuuministerioUuids.length > 0">
                        <span class="d-inline-block mr-2 info-label" v-translate>part.responsibility</span>
                        <template v-for="osavastuuministerioUuid in keino.osavastuuministerioUuids">
                            <span class="department-tag yja-tag">
                                {{ getMinisterioLyhenne(osavastuuministerioUuid) }}
                            </span>
                        </template>
                      </div>
                      <div class="clear"></div>
                    </div>
                  </div>
                  <div class="col-lg pb-0 pt-lg-0">
                    <Agenda2030Logo :valitavoite="keino" :json-api="jsonApi" />
                  </div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
    import LocalizedStringService from "../services/localizedStringService";
    import DateService from "../services/dateService";
    import Agenda2030Logo from "@/components/Agenda2030Logo";
    import ElementIdService from "@/services/elementIdService";

    const localizedStringService = new LocalizedStringService();
    const dateService = new DateService();
    const elementIdService = new ElementIdService();

    export default {
      components: {Agenda2030Logo},
      props: {
            rakenneElementti: Object,
            ministeriot: Array,
            kohdeLinkit: Object,
            kohteidenLinkit: Object,
            liittyvatKohdeUuids: Array,
            valitavoiteTyypit: Array,
            jsonApi: String
        },
        data: function() {
            return {
                localeState: "",
            }
        },
        beforeMount: function() {
            this.localeState = this.$translate.current;
        },
        computed: {
            filteredRakenneElementit() {
                if (this.rakenneElementit.length == 1) {
                    return this.rakenneElementit;
                } else {
                    return this.rakenneElementit.slice(1);
                }
            }
        },
        methods: {
            getMinisterioLyhenne(uuid) {
                let ministerio = this.ministeriot.find(function(ministerio) {
                    return ministerio.uuid === uuid
                });

                if (ministerio) {
                    return localizedStringService.getValue(ministerio.lyhenne, this.localeState);
                } else {
                    return "";
                }
            },
            getKohteidenLinkit(keino) {
                let linkit = [];
                keino.liittyvatKohdeUuids.forEach(kohdeUuid => {
                    const kohteenLinkit = this.kohteidenLinkit[kohdeUuid];
                    if (kohteenLinkit && kohteenLinkit.length > 0) {
                        linkit = linkit.concat(kohteenLinkit)
                    }
                });
                let seen = [];
                return linkit.filter(linkki => {
                    let similarSeen = similarLinkkiExists(seen, linkki, this.$translate.current);
                    seen.push(linkki);
                    return !similarSeen && !keinoHasSimilarLinkki(keino, linkki, this.$translate.current);
                });
            },
            kohdeLinkkiExists(kohdeUuid) {
                return this.kohdeLinkit[kohdeUuid] !== undefined;
            },
            getKohdeLinkki(kohdeUuid) {
                var linkkiData = this.kohdeLinkit[kohdeUuid];
                return linkkiData ? linkkiData.url : "";
            },
            getKohdeTunnus(kohdeUuid) {
                var linkkiData = this.kohdeLinkit[kohdeUuid];
                return linkkiData ? linkkiData.tunnus : "";
            },
            getValitatavoitteenTyypinNimi(valitavoiteTyyppiUuid) {
                let valitavoitteenTyyppi = "";
                this.valitavoiteTyypit.find(function(valitavoiteTyyppi) {
                    if (valitavoiteTyyppi.uuid === valitavoiteTyyppiUuid) {
                        return valitavoitteenTyyppi = valitavoiteTyyppi;
                    }
                });
                return localizedStringService.getValue(valitavoitteenTyyppi.nimi, this.localeState);
            },
            getValitatavoitteenTyypinIkoni(valitavoiteTyyppiUuid) {
                let valitavoitteenTyyppi = "";
                this.valitavoiteTyypit.find(function(valitavoiteTyyppi) {
                    if (valitavoiteTyyppi.uuid === valitavoiteTyyppiUuid) {
                        return valitavoitteenTyyppi = valitavoiteTyyppi;
                    }
                });
                if (valitavoitteenTyyppi.fontAwesomeClass) {
                    let parsedIconClass = [valitavoitteenTyyppi.fontAwesomeClass.split(' ')[0],
                                           valitavoitteenTyyppi.fontAwesomeClass.substring(valitavoitteenTyyppi.fontAwesomeClass.indexOf('-') + 1)];
                    return parsedIconClass;
                } else {
                    return "";
                }
            },
            getTranslation(text) {
              return this.$translate.text(text);
            },
            generateIdFromValitavoite(valitavoite) {
                let name = this.localizedStringValue(valitavoite.nimi);
                return elementIdService.generateIdFromName(name);
            },
            monthAndYearText(month, year) {
                return dateService.monthAndYearText(month, year, this.$translate.current);
            },
            localizedStringValue(localizedString) {
                return localizedStringService.getValue(localizedString, this.$translate.current);
            }
        }
    }

    function keinoHasSimilarLinkki(keino, linkki, locale) {
        return similarLinkkiExists(keino.linkit, linkki, locale);
    }

    function similarLinkkiExists(linkit, linkki, locale) {
        return linkit.find(existingLinkki => {
            return isSimilarLinkki(existingLinkki, linkki, locale);
        }) !== undefined;
    }

    function isSimilarLinkki(linkki1, linkki2, locale) {
      return localizedStringService.localizedStringEquals(linkki1.nimi, linkki2.nimi, locale) ||
          localizedStringService.localizedStringEquals(linkki1.url, linkki2.url, locale);
    }
</script>

